import FlightInfoTable from './FlightInfoTable';

export default FlightInfoTable;
